import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import Skeleton from '../../../common/skeleton';

const ClaimDetailsSkeleton = () => {
  return (
    <>
      <Row className="align-items-center">
        <Col md={12} lg={12} xs={12}>
          <Card className="pt-4 pb-4 pl-4 pr-4">
            <div className="first-block">
              <div className="text-center">
                <Skeleton
                  count={6}
                  height={12}
                  className="plan-details-skeleton"
                />
              </div>
            </div>
          </Card>
        </Col>
        {/*<Col md={4} lg={4} xs={12}>
          <Card className="pt-4 pb-4 pl-4 pr-4">
            <div className="first-block">
              <div className="text-center">
                <Skeleton
                  count={6}
                  height={12}
                  className="plan-details-skeleton"
                />
              </div>
            </div>
          </Card>
        </Col> */}
        {/*<Col md={4} lg={4} xs={12}>
          <Card className="pt-4 pb-4 pl-4 pr-4">
            <div className="first-block">
              <div className="text-center">
                <Skeleton
                  count={6}
                  height={12}
                  className="plan-details-skeleton"
                />
              </div>
            </div>
          </Card>
        </Col> */}
      </Row>
    </>
  );
};

export default ClaimDetailsSkeleton;
